import React, { Component } from 'react';
import countapi from 'countapi-js';

class VisitHome extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  async callAPI() {

    if (window.location.href.includes('mostafamilani.ir')) {

      await

        fetch("https://server-mostafamilani.iran.liara.run/record/63dbb621891d0e99d1f6cef9", {
          method: "GET",
          headers: {
            'Content-Type': 'application/json',
          },
        })
          .then(res => res.text())
          .then(res => this.setState({ apiResponse0: JSON.parse(res).contatore + 1 }));

      fetch("https://server-mostafamilani.iran.liara.run/update/63dbb621891d0e99d1f6cef9", {
        method: "POST",
        body: JSON.stringify({
          contatore: Number(this.state.apiResponse0),
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(res => res.text())
        .then(res => this.setState({ apiResponse: res }));


      fetch("https://server-mostafamilani.iran.liara.run/record/63dbb621891d0e99d1f6cef9", {
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(res => res.text())
        .then(res => this.setState({ apiResponse2: JSON.parse(res).contatore }));

    }

  }

  componentWillMount() {
    this.callAPI();
  }

  render() {

    return (
      <span style={{fontSize: '18px', color: '#30d5c8'}} title="Numero delle visite sulla homepage">👁 {this.state.apiResponse2}</span>
    );

  }
}

//   componentDidMount() {
//     countapi.visits('').then((result) => {
//       console.log(result)
//       this.setState({ visiteHome: result.value });
//     });
//   }

//   render() {

//     return (
//       <span style={{fontSize: '18px', color: '#30d5c8'}} title="Numero delle visite sulla homepage">(👁 {this.state.visiteHome})</span>
//     );

//   }
// }

export default VisitHome;